export const productDataList = [
  {
    productName: "Wheatgrass Juice",
    price: {
      mrp: 450,
      cost: 405,
      discountPercent: 10,
    },
    subcategory: 'Juice',
    productImage: "https://krishnaayurved.com/cdn/shop/products/WG1000_1_2e14c218-e414-4279-a890-09e38047b366_360x.jpg?v=1675917535",
    category: 'Immunity wellness',
    description: "Made from 9th day picked fresh wheatgrass leaves| Finest Herbal Detoxifier | Builds a Strong Immune System.",
    tagline: 'Finest Herbal Detoxifier | Builds a Strong Immune System',
    quantity: 1,
    seller: "665435aba128cc76290559d2",
  },
  {
    productName: "Wonder Hair Tonic, 100 ml ",
    price: {
      mrp: 800,
      cost: 800,
      discountPercent: 0,
    },
    subcategory: 'Hair care tonic',
    productImage: "https://ay.nice-cdn.com/upload/image/product/large/default/49432_c9004747.768x768.png",
    category: 'Hair care',
    description: "Oil-free & balancing care for your hair & scalp",
    tagline: 'New Arrival',
    quantity: 1,
    seller: "665435aba128cc76290559d2",
  },
  {
    productName: "Marigold and Winter cherry Deep moisturizing gel cream",
    price: {
      mrp: 1799,
      cost: 1400,
      discountPercent: 22,
    },
    subcategory: 'Dry skin',
    productImage: "https://vanauraorganics.com/cdn/shop/files/Marigold-and-Winter-cherry-Deep-moisturizing-gel-cream-for-Dry-skin.jpg?v=1697440179",
    category: 'Skin care',
    description: "Intense hydration,ultra light 72-hour moisture, brightens,elasticity booster for dry skin/ matured skin",
    tagline: 'New Arrival',
    quantity: 1,
    seller: "665435aba128cc76290559d2",
  },
  {
    productName: "Hair And Scalp Care Juice ",
    price: {
      mrp: 520,
      cost: 494,
      discountPercent: 10,
    },
    subcategory: 'Hair And Scalp Care Juice ',
    productImage: "https://krishnaayurved.com/cdn/shop/files/HairScalp_19_1800x1800.jpg?v=1695882007",
    category: 'Hair care ',
    description: "Blend of Powerful herbs | Natural ayurvedic hair care",
    tagline: 'Limited Stock',
    quantity: 1,
    seller: "665435aba128cc76290559d2",
  },
  {
    productName: "Kesharogyam Hair Oil",
    price: {
      mrp: 220,
      cost: 198,
      discountPercent: 10,
    },
    subcategory: 'Kesharogyam Hair Oil',
    productImage: "https://krishnaayurved.com/cdn/shop/products/HairOil_1_1800x1800.jpg?v=1669203458",
    category: 'Hair care',
    description: "Promotes Strong And Healthy Hair",
    tagline: 'Limited Stock',
    quantity: 1,
    seller: "665435aba128cc76290559d2",
  },
  {
    productName: "Diabic Care Juice 1000 ml | Diabic Tablet 80 tab ",
    price: {
      mrp: 1000,
      cost: 900,
      discountPercent: 10,
    },
    subcategory: 'Diabic Care',
    productImage: "https://krishnaayurved.com/cdn/shop/files/Combo_1800x1800.jpg?v=1702876792",
    category: 'Diabetic Wellness ',
    description: "Combo of diabic care juice and diabic care tab is formulated to regulate blood sugar levels.",
    tagline: '100% Ayurvedic & Herbal',
    quantity: 1,
    seller: "665435aba128cc76290559d2",
  },
  {
    productName: "FRESH & BRIGHT DAYS PACK (ALOE VERA PLUS JUICE + ALOE VERA SKIN CREAM)",
    price: {
      mrp: 570,
      cost: 449,
      discountPercent: 21,
    },
    subcategory: 'Juice and skin cream',
    productImage: 'https://www.shrichyawanayurved.com/cdn/shop/files/Ayurvediccaremedicineforbodydetoxificationandskincare_500x.webp?v=1695033468',
    category: 'Skin care',
    description: "Fresh & Bright Days Pack - Key Benefits Improves the Gut Health and boosts Immunity Reduces blemishes and spots",
    tagline: 'Best Seller',
    quantity: 1,
    seller: "65435aba128cc76290559d2",
  },
  {
    productName: 'Soft Heel Cream',
    price: {
      mrp: 180,
      cost: 170,
      discountPercent: 5,
    },
    subcategory: 'Soft Heel Cream',
    productImage: 'https://www.shrichyawanayurved.com/cdn/shop/files/creamforhealthyheal_500x.webp?v=1696316974',
    category: 'Skin care',
    description: ' Repairs cracked heels Prevents dryness & cracks on heels Smooth & crack-free heels Prevents discomfort in heels Nourishes & Moisturizes heels',
    tagline: '100% Ayurvedic & Herbal',
    quantity: 1,
    seller: "665435aba128cc76290559d2",
  },
  {
    productName: 'Herbal Turmeric Soap || A handmade Natural & Pure soap with Essentials Oil',
    price: {
      mrp: 199,
      cost: 179,
      discountPercent: 10,
    },
    subcategory: 'Soap',
    productImage: 'https://www.shrichyawanayurved.com/cdn/shop/files/TURMERIC_500x.webp?v=1714220244',
    category: 'Skin care',
    description: ' Maintains skins pH Balance Deep cleansing Helps in skin brightening Effective for Eczema, Skin Diseases Hydrates the skin Gives a radiant & glowing skin Provides cooling effect to the skin',
    tagline: 'Top Selling',
    quantity: 1,
    seller: "665435aba128cc76290559d2",
  },
  {
    productName: 'Herbal Lavender Soap || A handmade Natural & Pure soap with Essentials Oil',
    price: {
      mrp: 199,
      cost: 179,
      discountPercent: 10,
    },
    subcategory: 'Soap',
    productImage: 'https://www.shrichyawanayurved.com/cdn/shop/files/LavenderSoap_500x.jpg?v=1714636130',
    category: 'Skin care',
    description: ' Protects the skin from Free Radicals Helps to restore radiant & healthy skin Effective for Eczema, Skin Diseases',
    tagline: 'Top Selling',
    quantity: 1,
    seller: "665435aba128cc76290559d2",
  },
  {
    productName: "Ayurvedic Madhumoksha Vati for Sugar Management",
    price: {
      mrp: 399,
      cost: 349,
      discountPercent: 12,
    },
    subcategory: 'Diabic Care',
    productImage: "https://www.shrichyawanayurved.com/cdn/shop/files/Madhumokshavatiforsugartretment_500x.webp?v=1695200074",
    category: 'Diabetic Wellness ',
    description: 'Supports Cardiovascular Health Promotes Digestive Health May Support Healthy Bladder Function Supports Natural Energy Levels',
    tagline: 'New Arrival',
    quantity: 1,
    seller: "665435aba128cc76290559d2",
  },
  {
    productName: "AAyurvedic Medicine for Diabetes - Diabetes Care Kit",
    price: {
      mrp: 1795,
      cost: 1249,
      discountPercent: 30,
    },
    subcategory: 'Diabic Care',
    productImage: "https://www.shrichyawanayurved.com/cdn/shop/files/diabetescaremedicineforsugarcontrol_500x.webp?v=1694859717",
    category: 'Diabetic Wellness ',
    description: 'Helps maintain balanced blood sugar levels.Aids in maintaining healthy cholesterol levels Supports a Healthy Gut Helps maintain healthy digestion',
    tagline: 'New Arrival',
    quantity: 1,
    seller: "665435aba128cc76290559d2",
  },
  {
    productName: "Chandraprabha Vati (Swarn Bhasm)",
    price: {
      mrp: 499,
      cost: 399,
      discountPercent: 20,
    },
    subcategory: 'Diabic Care',
    productImage: "https://www.shrichyawanayurved.com/cdn/shop/files/chandraprabhavatiforimmunnesystem_500x.webp?v=1701163904",
    category: 'Diabetic Wellness',
    description: 'Prevents Urinary Tract Infections (UTIs) Supports Prostate Health Addresses Gynaecological Disorders Maintains Liver Health Aids in managing Joint discomfort Helps ease Muscle and Joint stiffness',
    tagline: 'Best Seller',
    quantity: 1,
    seller: "665435aba128cc76290559d2",
  },
  {
    productName: 'Apple Cider Vinegar',
    price: {
      mrp: 599,
      cost: 399,
      discountPercent: 33,
    },
    subcategory: 'Syrup',
    productImage: 'https://www.shrichyawanayurved.com/cdn/shop/files/applecidervinegar_500x.webp?v=1701260274',
    category: 'Acidity care',
    description: 'Regulates Blood Sugar levels Aids in Weight Loss Hydrates the skin Promotes Heart and Gut Wellness',
    tagline: 'Deal of the day',
    quantity: 1,
    seller: "665435aba128cc76290559d2",
  },
  {
    productName: 'Ayurvedic Syrup for Acidity - Acidity Amritam Syrup',
    price: {
      mrp: 199,
      cost: 189,
      discountPercent: 5,
    },
    subcategory: 'Syrup',
    productImage: 'https://www.shrichyawanayurved.com/cdn/shop/files/Acidityamritamsyrupforhyperacidity_500x.png?v=1702619827',
    category: 'Acidity care',
    description: 'Consume 10ml Morning and Evening after breakfast and snacks respectively which helps in Helps reduce Acidity,Reduces Uneasiness and Burping,Balances Stomach Acid,Promotes Digestive Health,Reduces Gase',
    tagline: 'Deal of the Day',
    quantity: 1,
    seller: "665435aba128cc76290559d2",
  },
  {
    productName: "Ayurvedic Medicine for Constipation - Kabj Hari",
    price: {
      mrp: 249,
      cost: 239,
      discountPercent: 4,
    },
    subcategory: 'Syrup',
    productImage: "https://www.shrichyawanayurved.com/cdn/shop/files/ayurvediccaremedicineforconstipation_500x.webp?v=1694858831",
    category: 'Acidity care',
    description: "Mix 1-2gm of this churn with half cup of water,consume everyday before going to bed which prevents Aids in chronic Constipation,Balances Stomach Acid,Helps reduce Hyperacidity,Promotes Digestive Health",
    tagline: '100% Ayurvedic product',
    quantity: 1,
    seller: "665435aba128cc76290559d2",
  },
  {
    productName: "Ayurvedic Medicine for Hyperacidity - Acidity Control Kit",
    price: {
      mrp: 1199,
      cost: 1427,
      discountPercent: 15,
    },
    subcategory: 'Syrup',
    productImage: "https://www.shrichyawanayurved.com/cdn/shop/files/Aciditycarekitforaciditytreatment_500x.webp?v=1695207902",
    category: 'Acidity care',
    description: "consume everyday before going to bed which prevents Aids in chronic Constipation,Balances Stomach Acid,Helps reduce Hyperacidity,Promotes Digestive Health",
    tagline: '100% Ayurvedic product',
    quantity: 1,
    seller: "665435aba128cc76290559d2",
  },
  {
    productName: "Aloe Vera Skin Cream",
    price: {
      mrp: 180,
      cost: 170,
      discountPercent: 5,
    },
    subcategory: 'Cream',
    productImage: "https://www.shrichyawanayurved.com/cdn/shop/files/Aloeverajuiceforrediantskin_500x.webp?v=1694856416",
    category: 'Skin care',
    description: "Gently massage on skin as moisturizer or on the affected area, For best results, use regularly,twice a day.",
    tagline: '100% Ayurvedic product',
    quantity: 1,
    seller: "665435aba128cc76290559d2",
  },
  {
    productName: "Ayurvedic Medicine for Itching - Itching Relief Kit",
    price: {
      mrp: 1057,
      cost: 799,
      discountPercent: 24,
    },
    subcategory: 'All in one medicine',
    productImage: "https://www.shrichyawanayurved.com/cdn/shop/files/Itchingreliefkitforitchingtreatment_500x.webp?v=1694860441",
    category: 'Skin care',
    description: "Relief from constant itching ,Fights Skin Infections ,Reduces Fungus Keeps skin irritation at bay Reduces rashes and skin inflammation,Helps restrict the spread of infection ",
    tagline: '100% Ayurvedic product',
    quantity: 1,
    seller: "665435aba128cc76290559d2",
  },
  {
    productName: "MyPrash Chyawanprash for Daily Health",
    price: {
      mrp: 349,
      cost: 234,
      discountPercent: 33,
    },
    subcategory: 'All in one medicine',
    productImage: "https://drvaidyas.com/cdn/shop/files/1_c9b29f7c-f373-437a-a5e2-080efecf5afc_720x.jpg?v=1720002679",
    category: 'Immunity wellness',
    description: " MyPrash Chyawanprash for Daily Health is an Ayurvedic immunity charger that helps fight seasonal allergies and build long-term immunity.It assists in increasing energy levels and improving your overall well-being with the help of Ayurveda. Comprising natural ingredients such as Amla, Haritaki, Gokshur, & Pippali, Dr. Vaidya’s My Prash Chyawanprash online is your go-to partner for improved immunity & all-day energy.  ",
    tagline: '100% Ayurvedic product',
    quantity: 1,
    seller: "665435aba128cc76290559d2",
  },
  {
    productName: "Fitness Pack: For Helping You Achieve Your Fitness Goals",
    price: {
      mrp: 499,
      cost: 399,
      discountPercent: 20,
    },
    subcategory: 'All in one medicine',
    productImage: "https://drvaidyas.com/cdn/shop/files/1_c9b29f7c-f373-437a-a5e2-080efecf5afc_720x.jpg?v=1720002679",
    category: 'Immunity wellness',
    description: "Fitness is now in your hands, literally! The goodness of ingredients such as Ashwagandha, Safed Musli, Amla and Shatavari help boost your energy levels, and build long-term immunity, muscle strength and stamina while also combating body fatigue.In addition to the above benefits, these tablets have no known side effects and are sugar-free.",
    tagline: '100% Ayurvedic product',
    quantity: 1,
    seller: "665435aba128cc76290559d2",
  },
  {
    productName: "MyPrash Chyawanprash for Daily Health",
    price: {
      mrp: 349,
      cost: 234,
      discountPercent: 33,
    },
    subcategory: 'All in one medicine',
    productImage: "https://drvaidyas.com/cdn/shop/products/Fitness-Pack_720x.jpg?v=1681990593",
    category: 'Immunity wellness',
    description: " MyPrash Chyawanprash for Daily Health is an Ayurvedic immunity charger that helps fight seasonal allergies and build long-term immunity.It assists in increasing energy levels and improving your overall well-being with the help of Ayurveda. Comprising natural ingredients such as Amla, Haritaki, Gokshur, & Pippali, Dr. Vaidya’s My Prash Chyawanprash online is your go-to partner for improved immunity & all-day energy.  ",
    tagline: '100% Ayurvedic product',
    quantity: 1,
    seller: "665435aba128cc76290559d2",
  },
  {
    productName: "Ashwagandha Capsules: For Better Immunity, Energy & Sleep",
    price: {
      mrp: 600,
      cost: 400,
      discountPercent: 33,
    },
    subcategory: 'All in one medicine',
    productImage: "https://drvaidyas.com/cdn/shop/files/1_c9b29f7c-f373-437a-a5e2-080efecf5afc_720x.jpg?v=1720002679",
    category: 'Immunity wellness',
    description: "Helps boost long-term immunity, Helps combat infections & illnesses, Helps boost energy levels & strength, Helps relieve stress & improve sleep quality ",
    tagline: '100% Ayurvedic product',
    quantity: 1,
    seller: "665435aba128cc76290559d2",
  }
];

export const bannerData = [
  { _id: 1, url: 'https://dwibhashi.co.in/images/slider-1.jpg' },
  { _id: 2, url: 'https://ayurvedamegastore.com/image/catalog/Blog%20Post/New%20Blog%20Images%20(5).jpg' },
  { _id: 3, url: 'https://www.torqueayurveda.com/wp-content/uploads/2020/07/ayurveda-banner-main.jpg' },
  { _id: 4, url: 'http://aikdesigns.com/blog/wp-content/uploads/2020/03/All-Product-1024x576.jpg' },
  { _id: 5, url: 'https://i.gadgets360cdn.com/large/Best-Ayurvedic-Creams-in-India-1557398002776.jpg' },
]